/**
 * PublishedHeroBlock — renderuje opublikowane hero z Kreatora pierwszego wrażenia
 * na publicznym profilu (/hodowla/:slug lub /firma/:slug).
 *
 * - Auto-detect mobile vs desktop z window width
 * - Jeśli brak opublikowanego configu (404), return null → istniejący layout strony bez zmian
 * - Pełna szerokość strony, bez kontenera (full-bleed hero)
 *
 * Props:
 *   entityType: 'kennel' | 'business'
 *   slug: string
 */
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE as API } from '@/utils/api';
import HeroPreview from '@/components/hero-creator/HeroPreview';

export default function PublishedHeroBlock({ entityType, slug }) {
  const [config, setConfig] = useState(null);
  const [device, setDevice] = useState(() => (typeof window !== 'undefined' && window.innerWidth < 768 ? 'mobile' : 'desktop'));

  useEffect(() => {
    const onResize = () => setDevice(window.innerWidth < 768 ? 'mobile' : 'desktop');
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!slug) return;
      try {
        const res = await axios.get(`${API}/api/hero-creator/public/${entityType}/${slug}`);
        if (cancelled) return;
        const cfg = res?.data?.config;
        if (cfg && cfg.headline) setConfig(cfg);
      } catch {
        /* 404 → no published hero → noop */
      }
    };
    load();
    return () => { cancelled = true; };
  }, [entityType, slug]);

  if (!config) return null;

  return (
    <section
      className="relative w-full bg-[#070710]"
      data-testid="published-hero-block"
      aria-label="Hero pierwszego wrażenia"
    >
      <div className="relative w-full" style={{ minHeight: device === 'mobile' ? 'auto' : '60vh' }}>
        <HeroPreview config={config} device={device} />
      </div>
    </section>
  );
}
